import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminAuthCallback() {
  const { completeOAuth } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    completeOAuth()
      .then(() => navigate("/admin/dashboard", { replace: true }))
      .catch((err) => setError(err.message || "Google sign-in failed"));
  }, [completeOAuth, navigate]);

  return (
    <main className="min-h-screen bg-[#2A080C] flex flex-col items-center justify-center p-6">
      <h1 className="font-['Cinzel_Decorative'] text-3xl text-amber-200 mb-4">Royal Vivah</h1>
      {error ? (
        <>
          <p role="alert" className="text-red-300 text-center mb-4">{error}</p>
          <Link className="text-amber-300 underline" to="/admin/login">Return to sign in</Link>
        </>
      ) : <p className="text-amber-200">Completing Google sign-in...</p>}
    </main>
  );
}
